import {WidgetController} from "../widgetController";

const updateDelayInMillisecond = 1000;

export class TreeMapController extends WidgetController {
  constructor(componentId, legends, updateCallback) {
    super(componentId, legends);
    this.historySize = 1;
    this.updateCallback = updateCallback;
    // this.startDelayedUpdate();
  }

  loadHistoricData(historicData) {
    let convertedData = {};
    for (let datasetId in historicData) {
      convertedData[datasetId] = historicData[datasetId][0];
    }
    const data = this.processData(convertedData);
    this.latestData = data;
    this.updateCallback(data);
  }

  update() {
    const data = this.processData();
    this.latestData = data;

    if (this.updateTimer) clearTimeout(this.timer);
    this.updateTimer = setTimeout(() => {
      this.updateCallback(this.latestData);
    }, 1000);
  }

  getHistorySize() {
    return this.historySize;
  }

  getLegends() {
    return this.legends;
  }

  onLegendUpdated() {
    // force update tree map
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.updateCallback(this.latestData);
    }, 300);
  }

  startDelayedUpdate() {
    this.timeout = setTimeout(() => {
      if (this.latestData) {
        this.updateCallback(this.latestData);
      }
      this.startDelayedUpdate();
    }, updateDelayInMillisecond);
  }

  destroy() {
    clearTimeout(this.timeout);
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/treeMap/controller.js